import { weijuCoreValues } from '@/mocks/weiju';
import Reveal from '@/components/base/Reveal';

export default function CoreValue() {
  return (
    <section id="value" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 border border-primary-200 text-xs md:text-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              核心价值是什么
            </div>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              味聚的五大核心价值
            </h2>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {weijuCoreValues.map((v, idx) => (
            <Reveal key={v.no} delay={idx * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-900 font-heading font-bold text-base">
                    {v.no}
                  </span>
                  <h3 className="font-heading font-bold text-lg text-foreground-950">{v.title}</h3>
                </div>
                <p className="mt-4 text-sm text-foreground-700 leading-relaxed">{v.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}